import { FC, useState } from 'react';
import { Release } from '../../models/release';
import ReleaseRow from './ReleaseRow';

export type ReleaseExtensionRowsProps = {
    releases: Release[];
    onReleaseSelect: (release: Release) => void;
    selectedRelease: Release | null;
}

const sort = (releases: Release[]) => {
    return [...releases].sort((a, b) => {
        if(a.version < b.version) { return 1; }
        if(a.version > b.version) { return -1; }
        return 0;
    });
}


const ReleaseExtensionRows: FC<ReleaseExtensionRowsProps> = ({releases, onReleaseSelect, selectedRelease}) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [sortedReleases] = useState<Release[]>(sort(releases));
    return (
        <>
            {
                sortedReleases.map((release, i) => (
                    <ReleaseRow
                        key={`${release.extension}-${release.version}`}
                        release={release}
                        isSelected={selectedRelease === release}
                        isLatest={i === 0}
                        onClick={() => onReleaseSelect(release)}
                        isCollapsed={isCollapsed}
                        toggleCollapse={() => setIsCollapsed(!isCollapsed)}
                        canCollapse={sortedReleases.length > 1}
                    />
                ))
            }
        </>
    );
}

export default ReleaseExtensionRows;
